<div class="container-fluid">
  <div class="row mb-3">

    <div class="card shadow-sm p-0">
      <div class="card-header">
        <h3 class="card-title">{{ checklistId ? 'Update Checklist' : 'Create Checklist' }} </h3>
      </div>
      <div class="card-body">
        <settings-projects-checklist-form [checklist]="checklist" (onSavedData)="onProjectFormSavedData($event)"
          (onFieldChange)="onFieldChange($event)" />
      </div>
    </div>
  </div>

  <settings-regulation-to-checklist [jurisdictionId]="jurisdictionId" [lawId]="lawId" [checklist]="checklist" />

</div>